import { pointsToWholePct } from '@silo/utils';
import { FC, ReactElement } from 'react';

interface BaseHealthFactorProps {
  displayPoints: number;
  bar: ReactElement;
  disabled?: boolean;
}

export const BaseHealthFactor: FC<BaseHealthFactorProps> = ({ displayPoints, bar, disabled = false }) => {
  const disabledClass = disabled ? 'opacity-50' : '';

  return (
    <div className={`space-y-2 ${disabledClass}`}>
      <div className="flex justify-between text-base">
        <div className="text-shale-200">Health factor</div>
        <div className="font-mono font-medium text-white" data-cy="health-factor-percentage">
          {pointsToWholePct(displayPoints)}
        </div>
      </div>
      <div>{bar}</div>
    </div>
  );
};
